// countries.js

const countries = [
    { name: "Australia", code: "AU" },
    { name: "Africa", code: "Africa" },
    { name: "Canada", code: "CA" },
    { name: "India", code: "IND" },
    
    { name: "United Kingdom", code: "UK" },
    { name: "United States", code: "US" },
    { name: "NA", code: "NA" },
   
  ];
  
  export default countries;
  